const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M20.0036%2039.5387L0%2019.7158V39.5387H20.0036Z'%20fill='%23133371'/%3e%3cpath%20d='M20.0034%2039.5387L39.9998%2019.7158V39.5387H20.0034Z'%20fill='%230066A9'/%3e%3cpath%20d='M20.0468%200V34.8956L2.4165%2017.412L20.0468%200Z'%20fill='%2300A6E2'/%3e%3c/svg%3e";
export {
  e as default
};
